import Tabs from "./tabs";
import {ConstructionComponentInfo} from "@interfaces/constructor/constructor";

const TabsInfo: ConstructionComponentInfo = {
    component: Tabs,
    props: [
        'initial_tab'
    ],
    addedChildProps: [
        'active_tab',
        'set_active_tab'
    ]
}

export {
    TabsInfo
}